import React from "react";
import InvoiceList from "../../billing/components/InvoiceList";

interface Props {
  companyId: string;
}

export const CompanyInvoicesSubscriptionTab: React.FC<Props> = ({
  companyId,
}) => <InvoiceList lockedCompanyId={companyId} />;
